<h2 mat-dialog-title> {{ organization?.name }}</h2>
<mat-dialog-content class="mat-typography">
  <page-map-view [latLong]="this.data.param.latLong" [address]="address"></page-map-view>         
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div  class="toogle" >
    <mat-slide-toggle  [(ngModel)]="checked" *ngIf="currentUser.type == 'practitioner'">Ativo</mat-slide-toggle>
  </div>  
  <button mat-button  color="primary" [mat-dialog-close]="false">Fechar</button>
 
</mat-dialog-actions>
